import { Text } from "@magnetic/text";

import { pluralize } from "src/utils/string";

import { VFlex } from "./vFlex";

import "./results.scss";
export const Results = ({ size = 0 }: { readonly size?: number }) => (
  <VFlex gap="xs" className="cnc-results-count">
    <Text color="light">
      {pluralize(size, `${size} result`, `${size} results`, "No results")}
    </Text>
  </VFlex>
);
